module.exports = __webpack_public_path__ + "static/img/solu3.5233542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu3.png
// module id = Lr1k
// module chunks = 1